import { Box, TextField, InputAdornment } from '@mui/material';
import { CalendarToday, Percent } from '@mui/icons-material';

interface CouponFormProps {
  discountAmount: string;
  couponCode: string;
  expirationDate: string;
  termsConditions: string;
  onDiscountAmountChange: (value: string) => void;
  onCouponCodeChange: (value: string) => void;
  onExpirationDateChange: (value: string) => void;
  onTermsConditionsChange: (value: string) => void;
}

const CouponForm = ({
  discountAmount,
  couponCode,
  expirationDate,
  termsConditions,
  onDiscountAmountChange,
  onCouponCodeChange,
  onExpirationDateChange,
  onTermsConditionsChange
}: CouponFormProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
        gap: 3
      }}
    >
      <TextField
        label="Discount Amount"
        placeholder="e.g., 20"
        value={discountAmount}
        onChange={(e) => onDiscountAmountChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Percent />
            </InputAdornment>
          )
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: 56,
            borderRadius: '8px',
            backgroundColor: '#F9FAFB',
            '& fieldset': {
              borderColor: '#D1D5DB'
            },
            '&:hover fieldset': {
              borderColor: '#9CA3AF'
            },
            '&.Mui-focused': {
              backgroundColor: 'white',
              '& fieldset': {
                borderColor: '#4F46E5'
              }
            }
          }
        }}
      />

      <TextField
        label="Coupon Code"
        placeholder="e.g., SAVE20"
        value={couponCode}
        onChange={(e) => onCouponCodeChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: 56,
            borderRadius: '8px',
            backgroundColor: '#F9FAFB',
            '& fieldset': {
              borderColor: '#D1D5DB'
            },
            '&:hover fieldset': {
              borderColor: '#9CA3AF'
            },
            '&.Mui-focused': {
              backgroundColor: 'white',
              '& fieldset': {
                borderColor: '#4F46E5'
              }
            }
          }
        }}
      />

      <TextField
        label="Expiration Date"
        placeholder="Select a date"
        type="date"
        value={expirationDate}
        onChange={(e) => onExpirationDateChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <CalendarToday />
            </InputAdornment>
          )
        }}
        InputLabelProps={{
          shrink: true
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: 56,
            borderRadius: '8px',
            backgroundColor: '#F9FAFB',
            '& fieldset': {
              borderColor: '#D1D5DB'
            },
            '&:hover fieldset': {
              borderColor: '#9CA3AF'
            },
            '&.Mui-focused': {
              backgroundColor: 'white',
              '& fieldset': {
                borderColor: '#4F46E5'
              }
            }
          }
        }}
      />

      <Box sx={{ gridColumn: { md: 'span 2' } }}>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Terms & Conditions"
          placeholder="Enter coupon terms and conditions..."
          value={termsConditions}
          onChange={(e) => onTermsConditionsChange(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
              backgroundColor: '#F9FAFB',
              '& fieldset': {
                borderColor: '#D1D5DB'
              },
              '&:hover fieldset': {
                borderColor: '#9CA3AF'
              },
              '&.Mui-focused': {
                backgroundColor: 'white',
                '& fieldset': {
                  borderColor: '#4F46E5'
                }
              }
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default CouponForm;

